import { HistoryLoader, TickAggregator, StructureEngine, ConfluenceEngine } from "../engine";

const ALL = { swings: true, bos: true, choch: true, cisd: true, t50: true, fvg: true, ob: true, liq: true };

// One analysis pass for any symbol × timeframe using the SAME engines the chart uses (single source of truth).
// Sub-minute timeframes are built from real ticks; ≥1m from Deriv candles. Never fabricates data.
export async function analyzeSymbol(symbol, tf, bars = 600) {
  let candles;
  if (tf.kind === "candle") candles = await HistoryLoader.candles(symbol, tf.seconds, bars);
  else {
    const ticks = await HistoryLoader.ticks(symbol, Math.min(5000, tf.kind === "tick" ? bars * (tf.ticks || 1) : bars * tf.seconds));
    const agg = new TickAggregator(tf, bars);
    agg.reset(ticks);
    candles = agg.candles;
  }
  if (!candles.length) return null;
  const structure = StructureEngine.analyze(candles, ALL);
  const confluence = ConfluenceEngine.score(candles, tf, structure);
  const last = candles[candles.length - 1];
  const ev = structure?.events ?? [];
  const lastBOS = [...ev].reverse().find((e) => e.type === "BOS") ?? null;
  const lastCHoCH = [...ev].reverse().find((e) => e.type === "CHoCH") ?? null;
  const comp = (id) => confluence?.components.find((c) => c.id === id) ?? null;
  const has = (c) => !!c && (c.bull > 0 || c.bear > 0);
  const bull = confluence?.bull ?? 0, bear = confluence?.bear ?? 0;
  return {
    symbol, tf: tf.id, price: last.close, time: last.time, bars: candles.length, candles, structure, confluence,
    direction: bull === bear ? "neutral" : bull > bear ? "bullish" : "bearish",
    score: Math.max(bull, bear), bull, bear,
    bos: has(comp("bos")) && /BOS/.test(comp("bos")?.state ?? ""), choch: /CHoCH/.test(comp("bos")?.state ?? ""),
    fvg: has(comp("fvg")), liquidity: has(comp("sweep")), tickDominance: has(comp("tickDominance")),
    cisd: structure?.cisd ? { state: structure.cisd.state, pending: structure.cisd.pending, last: structure.cisd.events.slice(-1)[0] ?? null } : null,
    t50: structure?.t50 ? { state: structure.t50.state, last: structure.t50.last, pending: structure.t50.pending, signals: structure.t50.events.length } : null,
    lastBOS, lastCHoCH, openFvg: (structure?.fvg ?? []).filter((g) => !g.filled).length, liquidityLevels: structure?.liquidity?.length ?? 0,
  };
}
